// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1AwsEndpointConnectionState } from './V1AwsEndpointConnectionState';
import {
  V1AwsEndpointConnectionStateFromJSON,
  V1AwsEndpointConnectionStateFromJSONTyped,
  V1AwsEndpointConnectionStateToJSON,
  V1AwsEndpointConnectionStateToJSONTyped,
} from './V1AwsEndpointConnectionState';

/**
 *
 * @export
 * @interface TrafficconfigAwsEndpointConnection
 */
export interface TrafficconfigAwsEndpointConnection {
  /**
   *
   * @type {string}
   * @memberof TrafficconfigAwsEndpointConnection
   */
  endpointId?: string;
  /**
   *
   * @type {V1AwsEndpointConnectionState}
   * @memberof TrafficconfigAwsEndpointConnection
   */
  state?: V1AwsEndpointConnectionState;
}

/**
 * Check if a given object implements the TrafficconfigAwsEndpointConnection interface.
 */
export function instanceOfTrafficconfigAwsEndpointConnection(
  value: object,
): value is TrafficconfigAwsEndpointConnection {
  return true;
}

export function TrafficconfigAwsEndpointConnectionFromJSON(
  json: any,
): TrafficconfigAwsEndpointConnection {
  return TrafficconfigAwsEndpointConnectionFromJSONTyped(json, false);
}

export function TrafficconfigAwsEndpointConnectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigAwsEndpointConnection {
  if (json == null) {
    return json;
  }
  return {
    endpointId: json['endpoint_id'] == null ? undefined : json['endpoint_id'],
    state:
      json['state'] == null
        ? undefined
        : V1AwsEndpointConnectionStateFromJSON(json['state']),
  };
}

export function TrafficconfigAwsEndpointConnectionToJSON(
  json: any,
): TrafficconfigAwsEndpointConnection {
  return TrafficconfigAwsEndpointConnectionToJSONTyped(json, false);
}

export function TrafficconfigAwsEndpointConnectionToJSONTyped(
  value?: TrafficconfigAwsEndpointConnection | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endpoint_id: value['endpointId'],
    state: V1AwsEndpointConnectionStateToJSON(value['state']),
  };
}
